(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('ProfileCriterionDialogController', ProfileCriterionDialogController);

    ProfileCriterionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProfileCriterion', 'ProfileCriterionItem'];

    function ProfileCriterionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProfileCriterion, ProfileCriterionItem) {
        var vm = this;

        vm.profileCriterion = entity;
        vm.clear = clear;
        vm.save = save;
        vm.profilecriterionitems = ProfileCriterionItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.profileCriterion.id !== null) {
                ProfileCriterion.update(vm.profileCriterion, onSaveSuccess, onSaveError);
            } else {
                ProfileCriterion.save(vm.profileCriterion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:profileCriterionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
